import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, type Stripe, type StripeElementsOptions } from "@stripe/stripe-js";
import { useMemo } from "react";
const loadStripeWithRetry = async (key: string, maxRetries = 3, delay = 1000): Promise<Stripe | null> => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      const stripe = await loadStripe(key);
      return stripe;
    } catch (error) {
      if (i === maxRetries - 1) {
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  return null;
};
const stripePromise = loadStripeWithRetry(
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY ?? "");
export const PaymentsProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const stripeOptions: StripeElementsOptions = useMemo(() => {
    return {
      mode: "setup",
      currency: "usd"
    };
  }, []);
  return <Elements stripe={stripePromise} options={stripeOptions} data-sentry-element="Elements" data-sentry-component="PaymentsProvider" data-sentry-source-file="PaymentsProvider.tsx">
      {children}
    </Elements>;
};